/** Typical donors shown in the preview table; values are illustrative, not tenant data. */
export const RFM_PREVIEW_PROFILES = [
    { key: "newDonor", monthsSinceLastDonation: 1, donationCount: 1, totalAmount: 40 },
    { key: "regular", monthsSinceLastDonation: 2, donationCount: 5, totalAmount: 600 },
    { key: "major", monthsSinceLastDonation: 4, donationCount: 2, totalAmount: 2500 },
    { key: "occasional", monthsSinceLastDonation: 9, donationCount: 2, totalAmount: 120 },
    { key: "lapsed", monthsSinceLastDonation: 30, donationCount: 1, totalAmount: 80 },
];
// Mirrors Opdon.Domain.Services.RfmScoreCalculator — keep both in sync (tests share their cases).
export function scoreRecency(months, t) {
    if (months <= t[0])
        return 5;
    if (months <= t[1])
        return 4;
    if (months <= t[2])
        return 3;
    if (months <= t[3])
        return 2;
    return 1;
}
export function scoreFrequency(count, t) {
    if (count >= t[3])
        return 5;
    if (count >= t[2])
        return 4;
    if (count >= t[1])
        return 3;
    if (count >= t[0])
        return 2;
    return 1;
}
export function scoreMonetary(amount, t) {
    if (amount > t[3])
        return 5;
    if (amount > t[2])
        return 4;
    if (amount > t[1])
        return 3;
    if (amount > t[0])
        return 2;
    return 1;
}
export function computeRfmScores(settings, profile) {
    const recency = scoreRecency(profile.monthsSinceLastDonation, settings.recency.thresholds);
    const frequency = scoreFrequency(profile.donationCount, settings.frequency.thresholds);
    const monetary = scoreMonetary(profile.totalAmount, settings.monetary.thresholds);
    // Integer division like the C# calculator — Math.trunc, not Math.round.
    const combined = Math.trunc((recency * settings.recency.weight + frequency * settings.frequency.weight + monetary * settings.monetary.weight) / 5);
    return { recency, frequency, monetary, combined };
}
